document.addEventListener("DOMContentLoaded", function () {
  var drawer = function () {
    var settings = {
      activeClass: "is-active",
      visibleClass: "is-visible",
      selectorTarget: "[data-drawer-target]",
      selectorTrigger: "[data-drawer-trigger]",
      selectorClose: "[data-drawer-close]",
    };

    var openDrawer = function (trigger) {
      var target = document.getElementById(
        trigger.getAttribute("aria-controls"),
      );
      target.classList.add(settings.activeClass);
      document.documentElement.style.overflow = "hidden";
      setTimeout(function () {
        gsap.to(".drawer__wrapper > div", {
          duration: 1,
          x: "0%",
          ease: "power2.out",
        });

        target.classList.add(settings.visibleClass);

        fetch("/cart.js")
          .then((resp) => resp.json())
          .then((data) => {
            var container = document.getElementById("cart__drawer_items");
            container.innerHTML = "";
            if (data.items.length > 0) {
              data.items.forEach(function (product) {
                console.log(product);
                // build DOM nodes for each item
                let fullImage = product.featured_image.url || "";
                let thumb = fullImage.replace(/(\.[^.]*)$/, "_350x400$1");
                var price = (product.final_line_price / 100).toFixed(2);

                var row = document.createElement("div");
                row.className =
                  "cart-item js--cart-item grid grid-cols-4 p-6 gap-6";

                var img = document.createElement("img");
                img.className =
                  "col-span-1 w-full h-full object-cover aspect-[4/5]";
                img.src = thumb;
                img.alt =
                  product.featured_image && product.featured_image.alt
                    ? product.featured_image.alt
                    : "";
                row.appendChild(img);

                var right = document.createElement("div");
                right.className = "col-span-3 flex flex-col justify-between";

                var grid = document.createElement("div");
                grid.className = "grid grid-cols-4 h-full grid-rows-2";

                var leftCol = document.createElement("div");
                leftCol.className = "col-span-3";
                var h5 = document.createElement("h5");
                h5.innerText = product.product_title;
                leftCol.appendChild(h5);
                // var spanSize = document.createElement("span");
                // spanSize.innerText = "Size";
                // leftCol.appendChild(spanSize);

                var actionsCol = document.createElement("div");
                actionsCol.className = "flex items-start justify-end";
                var removeBtn = document.createElement("button");
                removeBtn.type = "button";
                removeBtn.className = "cart_drawer_remove button-small";
                removeBtn.value = "0";
                removeBtn.setAttribute("data-id", product.id);
                removeBtn.setAttribute("data-key", product.key);
                removeBtn.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.6465 5.64651C17.8417 5.45125 18.1583 5.45125 18.3535 5.64651C18.5487 5.84178 18.5488 6.1583 18.3535 6.35355L12.707 12L18.3535 17.6465C18.5487 17.8418 18.5488 18.1583 18.3535 18.3535C18.1583 18.5488 17.8417 18.5488 17.6465 18.3535L12 12.7071L6.35352 18.3535C6.15827 18.5488 5.84175 18.5488 5.64648 18.3535C5.45122 18.1583 5.45122 17.8418 5.64648 17.6465L11.293 12L5.64648 6.35355C5.45122 6.15828 5.45122 5.84178 5.64648 5.64651C5.84175 5.45125 6.15825 5.45125 6.35352 5.64651L12 11.293L17.6465 5.64651Z" fill="#503429"/></svg>';
                actionsCol.appendChild(removeBtn);

                var qtyCol = document.createElement("div");
                qtyCol.className =
                  "col-span-3 flex items-end w-min h-min justify-start items-center bg-white gap-4 mt-auto body-l p-3 border";

                // hidden input used by updateLineItemQty
                var hidden = document.createElement("input");
                hidden.type = "number";
                hidden.className = "js--cart-item-qty hidden";
                hidden.setAttribute("data-key", product.key);
                hidden.setAttribute("data-id", product.id);
                hidden.value = product.quantity;
                qtyCol.appendChild(hidden);

                var minus = document.createElement("button");
                minus.className =
                  "cart_drawer_minus w-8 h-8 flex items-center justify-center";
                minus.setAttribute("data-key", product.key);
                minus.setAttribute("aria-label", "Decrease quantity");
                minus.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3.63306 9H14.1331" stroke="#503429" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                qtyCol.appendChild(minus);

                var qtySpan = document.createElement("span");
                qtySpan.className = "cart_drawer_qty";
                qtySpan.innerText = product.quantity;
                qtyCol.appendChild(qtySpan);

                var plus = document.createElement("button");
                plus.className =
                  "cart_drawer_plus w-8 h-8 flex items-center justify-center";
                plus.setAttribute("data-key", product.key);
                plus.setAttribute("aria-label", "Increase quantity");
                plus.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none"><path d="M9.5 3C9.91421 3 10.25 3.33579 10.25 3.75V8.25H14.75C15.1642 8.25 15.5 8.58579 15.5 9C15.5 9.41421 15.1642 9.75 14.75 9.75H10.25V14.25C10.25 14.6642 9.91421 15 9.5 15C9.08579 15 8.75 14.6642 8.75 14.25V9.75H4.25C3.83579 9.75 3.5 9.41421 3.5 9C3.5 8.58579 3.83579 8.25 4.25 8.25H8.75V3.75C8.75 3.33579 9.08579 3 9.5 3Z" fill="#503429"/></svg>';
                qtyCol.appendChild(plus);

                var priceP = document.createElement("p");
                priceP.className =
                  "flex items-end justify-end cart_drawer_price";
                priceP.innerText = "£" + price;

                grid.appendChild(leftCol);
                grid.appendChild(actionsCol);
                grid.appendChild(qtyCol);
                grid.appendChild(priceP);

                right.appendChild(grid);
                row.appendChild(right);

                container.appendChild(row);

                // event handlers
                removeBtn.addEventListener("click", function () {
                  // store previous quantity so we can revert on failure
                  hidden.dataset.prev = hidden.value;
                  hidden.value = 0;
                  row.classList.add("is-updating");
                  updateLineItemQty(hidden);
                });

                plus.addEventListener("click", function () {
                  // store previous quantity so we can revert on failure
                  hidden.dataset.prev = hidden.value;
                  var qty = parseInt(hidden.value, 10) || 0;
                  hidden.value = qty + 1;
                  qtySpan.innerText = hidden.value;
                  row.classList.add("is-updating");
                  updateLineItemQty(hidden);
                });

                minus.addEventListener("click", function () {
                  // store previous quantity so we can revert on failure
                  hidden.dataset.prev = hidden.value;
                  var qty = parseInt(hidden.value, 10) || 0;
                  var newQty = Math.max(0, qty - 1);
                  hidden.value = newQty;
                  qtySpan.innerText = hidden.value;
                  row.classList.add("is-updating");
                  updateLineItemQty(hidden);
                });
              });

              document.getElementById("cart__total_price").innerHTML =
                "£" + (data.total_price / 100).toFixed(2);
              var drawerCountEl =
                document.querySelector(".drawer__item_count") ||
                document.getElementById("drawer__item_count");
              if (drawerCountEl) {
                drawerCountEl.innerHTML =
                  "(" + (data.items ? data.items.length : 0) + ")";
              }
            } else {
              container.innerHTML = '<p class="p-6">Cart is empty</p>';
            }

            // listen for cart changes so we can clear updating state and update rows
            document.addEventListener("cart:line-item-updated", function (e) {
              try {
                var cart = e.detail && e.detail.cart ? e.detail.cart : null;
                if (!cart) return;

                console.debug("drawer:cart update event", cart.items);

                var rows = document.querySelectorAll(".js--cart-item");
                rows.forEach(function (rowEl) {
                  try {
                    var hiddenEl = rowEl.querySelector(".js--cart-item-qty");
                    if (!hiddenEl) return;
                    var key = hiddenEl.getAttribute("data-key");
                    var item = (cart.items || []).find(function (it) {
                      return it.key === key;
                    });
                    console.debug("drawer: syncing row", key, item);
                    if (item) {
                      // sync quantity and price
                      hiddenEl.value = item.quantity;
                      var qtySpan = rowEl.querySelector(".cart_drawer_qty");
                      if (qtySpan) qtySpan.innerText = item.quantity;
                      var priceEl = rowEl.querySelector(".cart_drawer_price");
                      if (priceEl) {
                        var formatted = Shopify.formatMoney(
                          item.final_line_price,
                        );
                        console.debug(
                          "drawer: setting price for",
                          key,
                          formatted,
                        );
                        priceEl.innerText = formatted;
                      }
                      rowEl.classList.remove("is-updating");
                    } else {
                      // removed from cart
                      rowEl.remove();
                    }
                    if (item) {
                      // per-row sync failed; continue
                      console.warn("drawer: per-row sync failed", inner);
                      // sync quantity and price
                      hiddenEl.value = item.quantity;
                      var qtySpan = rowEl.querySelector(".cart_drawer_qty");
                      if (qtySpan) qtySpan.innerText = item.quantity;
                      var priceEl = rowEl.querySelector(".cart_drawer_price");
                      if (priceEl)
                        priceEl.innerText = Shopify.formatMoney(
                          item.final_line_price,
                        );
                      rowEl.classList.remove("is-updating");
                    } else {
                      // removed from cart
                      console.warn("drawer: cart update handler failed", err);
                      rowEl.remove();
                    }
                  } catch (inner) {
                    // per-row sync failed; continue
                  }
                });

                // update totals
                var totalEl = document.getElementById("cart__total_price");
                if (totalEl)
                  totalEl.innerHTML = "£" + (cart.total_price / 100).toFixed(2);
                var countEl = document.getElementById("drawer__item_count");
                if (countEl)
                  countEl.innerHTML =
                    "(" + (cart.items ? cart.items.length : 0) + ")";
              } catch (err) {
                // ignore
              }
            });
          });

        document.getElementById("cart__drawer_items").style.paddingTop =
          document.getElementById("drawer__header").offsetHeight + "px";
        document.getElementById("cart__drawer_items").style.paddingBottom =
          document.getElementById("cart__drawer_footer").offsetHeight + "px";
      }, 50);
    };

    var closeDrawer = function (event) {
      gsap.to(".drawer__wrapper > div", {
        duration: 1,
        x: "100%",
        ease: "power2.in",
        onComplete: function () {
          var closestParent = event.closest(settings.selectorTarget);
          closestParent.classList.remove(settings.visibleClass);
          document.documentElement.style.overflow = "";
          setTimeout(function () {
            closestParent.classList.remove(settings.activeClass);
            document.getElementById("cart__drawer_items").innerHTML = "";
          }, 350);
        },
      });
    };

    var clickHandler = function (event) {
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);

      if (open) {
        openDrawer(open);
      }
      if (close) {
        closeDrawer(close);
      }
      if (open || close) {
        event.preventDefault();
      }
    };

    document.addEventListener("click", clickHandler, false);
  };

  drawer();
});
